import React from "react";
import { Row } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";

function PasswordWarningModel(props) {
  return (
    <Modal
      show={props.show}
      onHide={props.onHide}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          {props.heading}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>{props.bodytext}</p>
        {props.listHeading && <h5>{props.listHeading}</h5>}
        <Row>{props.list}</Row>
      </Modal.Body>
      <Modal.Footer>
        <Button
          className="primary button btn btn-primary"
          onClick={() => {
            props.onyes();
          }}
        >
          Change Password
        </Button>
        <Button
          className="outline btn button"
          onClick={() => {
            props.onHide();
          }}
        >
          Later
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
export default PasswordWarningModel;
